// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b2a2684b","703":"f0a6d1e8"}[chunkId] + ".chunk.js";
};